import { render, staticRenderFns } from "./CommonPleas.vue?vue&type=template&id=5108ca56&scoped=true&"
import script from "./CommonPleas.vue?vue&type=script&lang=js&"
export * from "./CommonPleas.vue?vue&type=script&lang=js&"
import style0 from "./CommonPleas.vue?vue&type=style&index=0&id=5108ca56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5108ca56",
  null
  
)

export default component.exports